import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5d4ff2c5")

_pushScopeId("data-v-5d4ff2c5")
const _hoisted_1 = { class: "border-b border-gray-lp-1400 p-4" }
const _hoisted_2 = { class: "flex flex-row gap-5 justify-between" }
const _hoisted_3 = { class: "font-bold text-black-lp-200 text-xl" }
const _hoisted_4 = { class: "flex items-center gap-3 mt-1" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = {
  class: "px-4 pb-4 pt-1",
  style: {"width":"60vw"}
}
const _hoisted_7 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_8 = { class: "text-base font-semibold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center gap-2.5 mt-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue = $event))
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("cariStt.scan.selectLocation")), 1),
            _createVNode("img", {
              src: _imports_0,
              class: " w-5 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelArea())),
              alt: "x"
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/icon-area-scan.svg`),
              class: "w-6"
            }, null, 8, ["src"]),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("cariStt.scan.selectLocationDescription")), 1)
          ])
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, idx) => {
            return (_openBlock(), _createBlock("div", {
              key: idx,
              class: 
            `flex items-center gap-1 border ${
              _ctx.dataArea.radioLocationArea === item.value ? 'bg-red-lp-1500 text-white' : ''
            } border-gray-lp-1400 p-3 rounded-full cursor-pointer`
          ,
              onClick: ($event: any) => (_ctx.onChangeRadioValue(item))
            }, [
              _createVNode(_component_RadioButton, {
                id: "rb-area-scan",
                value: item.value,
                modelValue: _ctx.dataArea.radioLocationArea,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataArea.radioLocationArea = $event)),
                name: "flight-time w-5"
              }, null, 8, ["value", "modelValue"]),
              _createVNode("span", _hoisted_8, _toDisplayString(item.name), 1)
            ], 10, ["onClick"]))
          }), 128))
        ]),
        (_ctx.dataArea.radioLocationArea === 'OTHERS')
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_LpInput, {
                type: "textarea",
                maxLength: "255",
                placeholder: _ctx.$t('cariStt.scan.othersPlaceholder'),
                showMaxLength: true,
                modelValue: _ctx.dataArea.locationArea,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataArea.locationArea = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_LpButton, {
            customClass: "px-10 py-2.5",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('cariStt.scan.cancel'),
            isWidthFull: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelArea()))
          }, null, 8, ["title"]),
          _createVNode(_component_LpButton, {
            customClass: "px-10 py-2.5",
            textColor: "white",
            title: _ctx.$t('cariStt.scan.confirmLocation'),
            isWidthFull: "",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmArea())),
            disabled: _ctx.disabledBtn
          }, null, 8, ["title", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})